import { LitElement, html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import componentStyles from './fil-loader.styles.js';

/**
 * @tag fil-loader
 * @property {string} [ariaValueText="Loading. Please wait. Do not refresh or navigate away from the page."] Aria text of the component
 * @property {"xs"|"small"|"medium or standard"| "large"} [size='medium'] Size of the component
 * @property {boolean} [determinate]
 * @property {"default" | "white" |"black"} [color] The visual color style of the loader
 * @property {number} [progress] Current value of progress with determinate loader
 * @property {string} [value] Show text that represents visual percentage or reminder.
 */
export class FilLoader extends LitElement {
  static properties = {
    ariaValueText: { type: String },
    size: { type: String },
    determinate: { type: Boolean },
    color: { type: String },
    progress: { type: Number },
    value: { type: String },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.ariaValueText = 'Loading. Please wait. Do not refresh or navigate away from the page.';
    this.size = 'standard';
  }

  makeRotation(rotation) {
    return !this.determinate ? undefined : `transform: rotate(${rotation}deg);`;
  }

  render() {
    const { progress, size, determinate, color, ariaValueText } = this;
    const styles = [
      this.makeRotation(-180 + (180 / 50) * Math.min(progress, 50)),
      this.makeRotation(-180 + (180 / 50) * Math.max(progress - 50, 0)),
    ];
    const masks = ['mask1', 'mask2'];
    const classes = {
      [`fil-loader--${size}`]: size,
      'fil-loader--indeterminate': !determinate,
      [`fil-loader--${color}`]: color,
    };
    return html`
      <div
        class="fil-loader-wrapper"
        aria-busy="${ifDefined(determinate && progress === 100 ? false : true)}"
      >
        <div
          class="fil-loader${classMap(classes)}"
          role="progressbar"
          aria-label="${ifDefined(
            determinate && progress === 100 ? 'Loading complete' : ariaValueText,
          )}"
          aria-valuenow=${ifDefined(determinate ? progress : undefined)}
          aria-valuemin=${ifDefined(determinate ? 0 : undefined)}
          aria-valuemax=${ifDefined(determinate ? 100 : undefined)}
        >
          <div class="fil-loader__track"></div>
          <div class="fil-loader__fills">
            ${masks.map(
              (mask, index) => html`
                <div class="fil-loader__fill-${mask}">
                  <div class="fil-loader__fill-sub-${mask}" style=${ifDefined(styles[index])}>
                    <div class="fil-loader__fill"></div>
                  </div>
                </div>
              `,
            )}
          </div>
        </div>
        ${this.value
          ? html`<div class="fil-loader__text" aria-labelledby="loadinglabel">${this.value}</div>`
          : nothing}
      </div>
    `;
  }
}
